import { headerHeightPx, mobileHeaderHeightPx } from 'common/constants/ui';

const styles = (theme) => ({
  container: {
    width: '100%',
    minHeight: `calc(100vh - ${headerHeightPx} - ${theme.spacing(15)}px)`,
    margin: theme.spacing(5, 'auto', 10),
    padding: theme.spacing(0, 2),
    [theme.breakpoints.down('md')]: {
      minHeight: `calc(100vh - ${mobileHeaderHeightPx} - ${theme.spacing(8)}px)`,
      margin: theme.spacing(4, 'auto'),
      padding: theme.spacing(0, 2),
    },
  },
});

export default styles;
